import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { PageHero } from "../../components/public/Section";
import { Calendar, Tag, Eye, ArrowLeft } from "lucide-react";

export default function AnnouncementDetail() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/announcements/${slug}`).then((r) => setA(r.data)).catch(() => setNotFound(true));
  }, [slug]);
  if (notFound) return <div className="section container-page text-center text-brand-muted">Announcement not found. <Link to="/announcements" className="text-brand-primary font-semibold">View all</Link></div>;
  if (!a) return <div className="section container-page text-center text-brand-muted">Loading…</div>;
  return (
    <div>
      <PageHero title={a.title} subtitle={a.summary} breadcrumbs={["Home", "Announcements"]} />
      <section className="section container-page max-w-3xl">
        <div className="text-sm text-brand-muted flex flex-wrap items-center gap-5 mb-6">
          <span className="flex items-center gap-1.5"><Calendar size={14} /> {new Date(a.publish_date).toLocaleDateString()}</span>
          <span className="flex items-center gap-1.5"><Tag size={14} /> {a.category}</span>
          <span className="flex items-center gap-1.5"><Eye size={14} /> {a.views} views</span>
        </div>
        {a.image && <img src={a.image} alt={a.title} className="rounded-2xl w-full mb-8 shadow-card" />}
        <div className="prose max-w-none text-brand-text leading-relaxed whitespace-pre-line">{a.description}</div>
        {a.tags?.length > 0 && <div className="mt-8 flex flex-wrap gap-2">{a.tags.map((t) => <span key={t} className="px-3 py-1 rounded-full bg-brand-primary-light text-brand-primary text-xs font-semibold">#{t}</span>)}</div>}
        <Link to="/announcements" className="btn-ghost mt-10"><ArrowLeft size={16} /> Back to all announcements</Link>
      </section>
    </div>
  );
}
